import React, { useEffect, useState } from "react";

export default (props) => {
  const [view, setView] = useState(true);
  const [viewText, setViewText] = useState();

  const msgArray = [
    "기기의 '∧'를 누르십시요.                                                               ",
    "'bt'문자를 확인해주세요.                                                              ",
    "'연결'버튼을 누르십시요.                                                              ",
    "'연결중'상태를 확인하십시요.                                                          ",
    "기기가 연결되면 '연결해제'를 확인하실 수 있습니다.                                    ",
    "기기가 연결된 후 기기의 '전원'버튼을 길게 눌러 OFF가 확인되시면 세부 설정이 가능합니다.",
    "'전원'을 10회를 눌러 On Auto Send를 확인하십시요. OFF인 경우 '∨'를 눌러 ON으로 변경하십시요.",
  ];

  const toastDivStyle = {
    background: "rgb(0, 0, 0, 0.5)",
    color: "#fff",
    width: "79vw",
    height: "64px",
    // , height: "50px"
    padding: "10px 20px",
    borderRadius: "16px",
    position: "absolute",
    bottom: "12px",
    zIndex: "20",
    fontSize: "16px",
    transform: "translate3d(0, 0, 0)",
  };

  const bottomCenter = {
    display: "flex",
    justifyContent: "center",
  };

  const resetViewText = () => {
    setView(false);
    setViewText("");
  };

  const settingViewText = () => {
    setViewText(msgArray[props.msgIdx - 1]);
    setView(true);
  };

  useEffect(() => {
    resetViewText();

    if (view === false) {
      $("#viewText").text("");
    }

    setTimeout(() => {
      settingViewText();
    }, 50);
  }, [props.msgIdx]);

  return (
    <div style={bottomCenter}>
      <div style={toastDivStyle} id="viewText">
        {view && viewText}
      </div>
    </div>
  );
};

export const ToastMessageOmron = (props) => {
  const [view, setView] = useState(true);
  const [viewText, setViewText] = useState();
  const msgArray = [
    "기기의 'B'를 길게 누르십시요",
    "앱 하단의 '연결' 버튼을 누르십시요",
    "BlueTooth 페어링 요청(아이폰) 팝업이 나타나면 '확인' 또는 '페어링' 버튼을 눌러주세요",
    "앱에 '연결중'상태를 확인하십시요",
    "기기에 'P'가 깜빡거리는 걸 확인하십시요",
    "기기가 연결이 완료되면 기기 상단에 'OK'가 표시 됩니다",
    "기기의 START버튼을 눌러 혈압을 측정하십시요",
  ];

  const toastDivStyle = {
    background: "rgb(0, 0, 0, 0.5)",
    color: "#fff",
    width: "79vw",
    height: "64px",
    // , height: "50px"
    padding: "10px 20px",
    borderRadius: "16px",
    position: "absolute",
    bottom: "12px",
    zIndex: "20",
    fontSize: "16px",
    transform: "translate3d(0, 0, 0)",
    transform: "translateZ(0)",
  };

  const bottomCenter = {
    display: "flex",
    justifyContent: "center",
  };

  const resetViewText = () => {
    setView(false);
    setViewText("");
  };

  const settingViewText = () => {
    setViewText(msgArray[props.msgIdx - 1]);
    setView(true);
  };

  useEffect(() => {
    resetViewText();

    if (view === false) {
      $("#viewText").text("");
    }

    setTimeout(() => {
      settingViewText();
    }, 50);
  }, [props.msgIdx]);

  return (
    <div style={bottomCenter}>
      <div style={toastDivStyle} id="viewText">
        {view && viewText}
      </div>
    </div>
  );
};
